export default Vue => {
  Vue.component("v-icon", () => import("./v-icon.vue"));
};
